// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"167":"2d66a947","295":"1453759b","394":"825eb735","905":"a20fe20a"}[chunkId] + ".css";
};